import Collapse from "@mui/material/Collapse";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import SpecimenTypeAssigmentService from "../../../Services/Compendium/SpecimenTypeAssigmentService";
import PermissionComponent, {
  getPermissionDisplayName,
} from "../../../Shared/Common/Permissions/PermissionComponent";
import useLang from "Shared/hooks/useLanguage";

import { reactSelectStyle, styles } from "../../../Utils/Common";
import BreadCrumbs from "../../../Utils/Common/Breadcrumb";
import AddReportDisclaimer from "./AddReportDisclaimer";

export interface LinksArray {
  text: string;
  link: string;
}
interface Requisition {
  value: number;
  label: string;
}
interface RequisitionDetails {
  reqTypeId: number;
  requisitionTypeName: string;
}
function ReportDisclaimerNavber({
  open,
  errors,
  panels,
  values,
  setOpen,
  request,
  sports2,
  loadData,
  setErrors,
  openModal,
  setValues,
  setPanels,
  setSports2,
  AddBtnText,
  setRequest,
  setSorting,
  setCurPage,
  modalheader,
  setOpenModal,
  handleSubmit,
  searchRequest,
  selectedPanels,
  handleOnChange,
  editGridHeader,
  setSearchRequest,
  setSelectedPanels,
  setEditGridHeader,
  disableSavebutton,
  setTriggerSearchData,
  initialSearchRequestObj,
}: any) {
  const { t } = useLang();

  const [show, isShow] = useState<boolean>(false);
  const [RequsitionList, setRequsitionList] = useState<Requisition[]>([]);

  type InputChangeEvent = HTMLInputElement | HTMLSelectElement;
  const onInputChangeSearch = (e: React.ChangeEvent<InputChangeEvent>) => {
    if (e.target.name === "isactive") {
      setSearchRequest((pre: any) => {
        return {
          ...pre,
          [e.target.name]: str2bool(e.target.value),
        };
      });
    } else {
      setSearchRequest({ ...searchRequest, [e.target.name]: e.target.value });
    }
  };
  var str2bool = (value: string) => {
    if (value && typeof value === "string") {
      if (value.toLowerCase() === "true") return true;
      if (value.toLowerCase() === "false") return false;
      if (value.toLowerCase() === "null") return null;
    }
  };

  const resetSearch = () => {
    loadData(true);
    setSorting({
      sortColumn: "id",
      sortDirection: "desc",
    });
    setSearchRequest(initialSearchRequestObj);
  };

  const GetRequsition = () => {
    SpecimenTypeAssigmentService.RequisitionTypeLookup().then((res: any) => {
      let RequisitionArray: Requisition[] = [];
      res?.data?.data.forEach(
        ({ reqTypeId, requisitionTypeName }: RequisitionDetails) => {
          let RequisitionDetails: Requisition = {
            value: reqTypeId,
            label: requisitionTypeName,
          };
          RequisitionArray.push(RequisitionDetails);
        }
      );

      setRequsitionList(RequisitionArray);
    });
  };

  const onRequisitionSelect = (e: any, name: string) => {
    setSearchRequest({ ...searchRequest, [name]: e.label });
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      setCurPage(1);
      setTriggerSearchData((prev: any) => !prev);
    }
  };

  useEffect(() => {
    GetRequsition();
  }, []);

  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-2 py-lg-3">
        <div className="app-container container-fluid d-flex flex-wrap gap-4 justify-content-center justify-content-sm-between align-items-center">
          <BreadCrumbs />
          <div className="d-flex align-items-center gap-2 gap-lg-3 responsive-flexed-actions-reverse">
            <button
              id={`ReportDisclaimerOpenSearch`}
              className={`btn btn-info btn-sm fw-bold search ${
                open || openModal ? "d-none" : "d-block"
              }`}
              onClick={() => {
                setOpen(!open);
                if (openModal) {
                  setOpenModal(!openModal);
                }
              }}
              aria-controls="SearchCollapse"
              aria-expanded={open}
            >
              <i className="fa fa-search"></i>
              <span>{t("Search")}</span>
            </button>
            <button
              id={`ReportDisclaimerCloseSearch`}
              className={`btn btn-info btn-sm fw-bold ${
                open ? "btn-icon" : "collapse"
              }`}
              onClick={() => setOpen(!open)}
              aria-controls="SearchCollapse"
              aria-expanded={open}
            >
              <i className="fa fa-times p-0"></i>
            </button>
            <PermissionComponent
              moduleName="Setup"
              pageName="Report Disclaimer"
              permissionIdentifier="Add"
            >
              {({ pageName, moduleName, permissionIdentifier }) => (
                <button
                  id={`ReportDisclaimerAddNew`}
                  className={`btn btn-sm fw-bold btn-primary ${
                    openModal ? "d-none" : "d-block"
                  }`}
                  onClick={() => {
                    setOpenModal(!openModal);
                    if (open) {
                      setOpen(!open);
                    }
                  }}
                  aria-controls="ModalCollapse"
                  aria-expanded={openModal}
                >
                  <span className="">
                    {getPermissionDisplayName(
                      pageName,
                      moduleName,
                      permissionIdentifier,
                      AddBtnText
                    )}
                  </span>
                </button>
              )}
            </PermissionComponent>
          </div>
        </div>
      </div>

      <Collapse in={open}>
        <div className="app-content flex-column-fluid">
          <div className="app-container container-fluid ">
            <div id="SearchCollapse" className="card">
              <div id="form-search" className=" card-body">
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <div className="fv-row mb-4">
                      <label className="mb-2">{t("Requisition Type")}</label>
                      <Select
                        inputId={`ReportDisclaimerRequisitionTypeSearch`}
                        menuPortalTarget={document.body}
                        styles={reactSelectStyle}
                        theme={(theme: any) => styles(theme)}
                        options={RequsitionList}
                        name="reqTypeId"
                        placeholder={t("Select Requisition Type")}
                        value={RequsitionList.filter(function (option: any) {
                          return option.label === searchRequest.reqTypeName;
                        })}
                        onChange={(e: any) =>
                          onRequisitionSelect(e, "reqTypeName")
                        }
                        isSearchable={true}
                        className="z-index-3"
                        onKeyDown={handleKeyPress}
                      />
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <div className="fv-row mb-4">
                      <label className="mb-2">{t("Panel Name")}</label>
                      <input
                        id={`ReportDisclaimerPanelNameSearch`}
                        type="text"
                        name="panelName"
                        value={searchRequest.panelName}
                        onChange={(e) => onInputChangeSearch(e)}
                        className="form-control bg-transparent"
                        placeholder={t("Panel Name")}
                        onKeyDown={handleKeyPress}
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-end  gap-2 gap-lg-3">
                    <button
                      id={`ReportDisclaimerSearch`}
                      onClick={() => {
                        setCurPage(1);
                        setTriggerSearchData((prev: any) => !prev);
                      }}
                      className="btn btn-primary btn-sm btn-primary--icon"
                    >
                      <span>
                        <i className="fa fa-search"></i>
                        <span>{t("Search")}</span>
                      </span>
                    </button>
                    <button
                      type="reset"
                      onClick={(e) => resetSearch()}
                      className="btn btn-secondary btn-sm btn-secondary--icon"
                      id={`ReportDisclaimerReset`}
                    >
                      <span>
                        <i className="fa fa-times"></i>
                        <span>{t("Reset")}</span>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Collapse>
      <AddReportDisclaimer
        values={values}
        isShow={isShow}
        errors={errors}
        panels={panels}
        sports2={sports2}
        request={request}
        loadData={loadData}
        openModal={openModal}
        setErrors={setErrors}
        setPanels={setPanels}
        setValues={setValues}
        setRequest={setRequest}
        setSports2={setSports2}
        modalheader={modalheader}
        handleSubmit={handleSubmit}
        setOpenModal={setOpenModal}
        handleOnChange={handleOnChange}
        editGridHeader={editGridHeader}
        selectedPanels={selectedPanels}
        disableSavebutton={disableSavebutton}
        setEditGridHeader={setEditGridHeader}
        setSelectedPanels={setSelectedPanels}
      />
    </div>
  );
}

export default ReportDisclaimerNavber;
